import {
  collectPaymentRequestSchema,
  type CollectPaymentRequest,
  type InvoiceDetail,
} from "@stb/api-contract"
import { createServerFn } from "@tanstack/react-start"
import { z } from "zod"

import { collectPayment, generateInvoicePdf } from "../collect.server"
import { createInvoiceSendDeps } from "../send-deps.server"
import { getLogoStorage } from "../storage.server"
import { runAction, type RpcResult } from "./context"

/** Collect payment server functions (T476). The organisation always comes from the session. */

export const collectPaymentAction = createServerFn({ method: "POST" })
  .validator((data: CollectPaymentRequest) => collectPaymentRequestSchema.parse(data))
  .handler(async ({ data }): Promise<RpcResult<InvoiceDetail>> =>
    runAction(({ context }) => collectPayment(data, context, new Date(), getLogoStorage())),
  )

/** Makes (or remakes) the PDF of an issued invoice, with the PAID details when it is paid. */
export const generateInvoicePdfAction = createServerFn({ method: "POST" })
  .validator((data: { id: string }) => z.object({ id: z.uuid() }).parse(data))
  .handler(async ({ data }): Promise<RpcResult<InvoiceDetail>> =>
    runAction(({ context }) => {
      const { pdf, storage } = createInvoiceSendDeps()
      return generateInvoicePdf(data.id, context, { pdf, storage })
    }),
  )
